import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "DashboardRestoration"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M11.0017 1.01828V2.56321H11.5966C12.0404 2.56321 12.1876 2.84243 11.9203 3.19243L10.4797 5.08007C10.2144 5.42771 9.78663 5.43007 9.51931 5.08007L8.0783 3.19243C7.81339 2.84478 7.95945 2.56321 8.40244 2.56321H8.9973V1.01828C8.9973 0.966303 9.00778 0.914842 9.02814 0.866871C9.0485 0.818901 9.07834 0.775372 9.11592 0.738803C9.15351 0.702234 9.19809 0.673349 9.24711 0.653818C9.29612 0.634288 9.34859 0.6245 9.40147 0.62502H10.5976C10.8209 0.62502 11.0017 0.80002 11.0017 1.01828Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M9.31265 6.07398L7.50342 3.84146C7.33509 3.748 7.15384 3.68361 6.96773 3.6482L7.40302 7.3217C7.43657 7.60485 7.70028 7.80009 7.97746 7.74699L9.55729 7.44436C9.75361 7.40558 9.95937 7.48061 10.0801 7.63569L11.0525 8.87945C11.2135 9.08531 11.5059 9.12745 11.7173 8.97527L12.7635 8.22235C12.8193 8.18221 12.8558 8.1202 12.864 8.05151L13.3982 3.61584C13.0852 3.61245 12.7713 3.68834 12.493 3.84391L10.6861 6.07398C10.3067 6.58238 9.69493 6.58583 9.31265 6.07398Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M7.66612 8.81103L9.44859 8.46958L10.5184 9.8379C10.6818 10.0469 10.9251 10.1851 11.1947 10.222C11.4643 10.2589 11.7382 10.1916 11.9561 10.0348L13.4673 8.9472C13.6784 8.79523 13.8204 8.57109 13.8638 8.32132L14.3868 3.91711C15.1789 4.39844 16.1838 5.17887 16.5173 6.18127C16.5444 6.26263 16.5722 6.34506 16.6002 6.42817C17.171 8.12194 17.8629 10.175 15.7945 12.4706C15.7945 12.4706 16.9516 17.0208 14.2031 19.1618C14.2031 19.1618 12.1968 19.9977 12.4675 18.3587C12.644 17.2947 12.6311 13.3509 9.99989 13.1582C7.36925 13.3509 7.35633 17.2942 7.53231 18.3587C7.80356 19.9977 5.79613 19.1618 5.79613 19.1618C3.04871 17.0208 4.20526 12.4706 4.20526 12.4706C2.13718 10.1743 2.82902 8.12136 3.39983 6.42753C3.42778 6.34458 3.45545 6.26249 3.48248 6.18127C3.82854 5.14118 4.89737 4.34007 5.70249 3.86409C5.78008 3.81831 5.86068 3.77886 5.94348 3.74572L6.45283 8.0105C6.49939 8.2728 6.65461 8.50587 6.88315 8.65667C7.11169 8.80746 7.39411 8.86314 7.66612 8.81103Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var dashboardRestoration = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { dashboardRestoration as default };
